'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './db-admin-edit.routes';

export class DbAdminEditComponent {
  constructor(DBAdminService, Auth, $state, $stateParams, dialogs, Config, $location) {
    'ngInject';

    this.DBAdminService = DBAdminService;

    this.entityId = $stateParams.id;
    this.collection = $stateParams.collection;

    this.$location = $location;

    this.dialogs = dialogs;

    this.jsonValue = "";
    this.$state = $state;

    this.DBAdminService.get({collection: this.collection, id: this.entityId}, data => {
      this.jsonValue = angular.toJson(data, true);
    }, err => {
      console.log('Could not load entity from server');
    });

    CodeMirror.defineOption("matchBrackets", true);
    CodeMirror.defineOption("autoCloseBrackets", true);
    CodeMirror.defineOption("lineWrapping", true);
    CodeMirror.defineOption("tabSize", 2);
    CodeMirror.defineOption("mode", "application/json");
    CodeMirror.defineOption("gutters", ["CodeMirror-lint-markers"]);
    CodeMirror.defineOption("lint", true);
    CodeMirror.defineOption("styleActiveLine", true);
    CodeMirror.defineOption("lineNumbers", true);
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        this.submitted = false;

        var dlg = this.dialogs.notify("Success", "The entity has been saved successfully");
        dlg.result.then(() => {
          that.$location.url("/db-admin/"+that.collection);
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.DBAdminService.update({collection: this.collection, id: this.entityId}, angular.fromJson(this.jsonValue), onSuccess, onError);

    }
  }
}

export default angular.module('conduu.ap.dbAdmin.edit', [uiRouter])
  .config(routes)
  .component('dbAdminEdit', {
    template: require('./db-admin-edit.html'),
    controller: DbAdminEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/superadmin/db/edit/db-admin-edit.component.js